import React, { Component } from 'react';
import OLVectorSource from 'ol/source/vector';

class VectorSource extends Component {
  constructor(props) {
    super(props);

    this.vectorSource = new OLVectorSource({});
    this.vectorSource.on('change', (e) => {
      if (this.vectorSource.getState() == 'ready' && this.props.onReady) {
        this.props.onReady(this.vectorSource);
      }
    });
  }

  componentDidMount() {
    const { vectorLayer, features } = this.props;
    this.vectorSource.addFeatures(features);
    vectorLayer.setSource(this.vectorSource);
  }

  componentWillUnmount() {
    const { vectorLayer } = this.props;
    this.vectorSource.clear();

    vectorLayer.setSource(null); // << not sure how to clean this up yet
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.features != this.props.features) {
      this.vectorSource.clear();
      this.vectorSource.addFeatures(nextProps.features);
    }
  }

  render() {
    return null;
  }
}

VectorSource.defaultProps = {
  features: []
}

export default VectorSource;



// WEBPACK FOOTER //
// ./src/components/ol/VectorSource.js